module.exports = __webpack_public_path__ + "img/grenade.beancan.65ae730b.png";